import { api, unwrapList } from '../../../shared/lib/axios';

export interface Estado {
  uf: string;
  nome: string;
  regiao: string;
}

export interface Municipio {
  idIbge: number;
  uf: string;
  nome: string;
}

export async function listarEstados(): Promise<Estado[]> {
  // Backend embrulha listas em { version, _links, data: [...] } via interceptor
  // HATEOAS global — desembrulhamos aqui.
  const { data } = await api.get<Estado[] | { data?: Estado[] }>('/geo/estados');
  return unwrapList<Estado>(data);
}

export async function listarMunicipios(uf: string): Promise<Municipio[]> {
  const { data } = await api.get<Municipio[] | { data?: Municipio[] }>(
    `/geo/estados/${uf}/municipios`,
  );
  return unwrapList<Municipio>(data);
}
